// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyDQY7abAPM9pfQ6oR2dg8HauHQ53iCeSXY',
    authDomain: 'borneofest-3fea0.firebaseapp.com',
    projectId: 'borneofest-3fea0',
    storageBucket: 'borneofest-3fea0.appspot.com',
    messagingSenderId: '513761564996',
    appId: '1:513761564996:web:c8d63c03f209b18f591f11',
    measurementId: 'G-E77NZDMNL7',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
